import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  scadenze: [],
};

const scadenzeSlice = createSlice({
  name: 'contratti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = !!action.payload;
    },
    aggiornaScadenze(state, action) {
      state.scadenze = action.payload;
    },
  },
});

export const { caricamento, aggiornaScadenze } = scadenzeSlice.actions;
const scadenzeReducer = scadenzeSlice.reducer;

export default scadenzeReducer;
